import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import * as EmployeeModels from '@employee-models/index';
import {Observable} from 'rxjs';
import {AppConfigurationService} from '@ui-app/services/app-configuration.service';

@Injectable({
    providedIn: 'root'
})
export class AppResolve implements Resolve<EmployeeModels.DM.IFeaturesConfiguration> {

    constructor(
        private appConfigurationService: AppConfigurationService
    ) {}

    resolve(): Observable<EmployeeModels.DM.IFeaturesConfiguration> {
        return this.appConfigurationService.getConfiguration();
    }
}
